import React, { Component } from 'react';
import PropTypes from 'prop-types';
import roundEmptyPng from 'images/round-empty.png';
import roundFullPng from 'images/round-full.png';
import roundFullReadOnlySvg from 'images/round-full-readonly.svg';
import './RadioButton.css';

class RadioButton extends Component {
  static propTypes = {
    className: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      })
    ).isRequired,
    emptyPng: PropTypes.any,
    fullPng: PropTypes.any,
    fullPngReadOnly: PropTypes.any,
    orientation: PropTypes.oneOf(['horizontal', 'vertical', 'table']),
    readOnly: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
  };

  static defaultProps = {
    emptyPng: null,
    fullPng: null,
    fullPngReadOnly: null,
    orientation: 'horizontal',
    readOnly: false,
  };

  handleChange = (event, value) => {
    event.preventDefault();
    if (this.props.onChange && !this.props.readOnly) {
      this.props.onChange(value);
    }
  };

  render() {
    return (
      <div
        className={
          'radio-button' +
          (this.props.className !== undefined ? ' ' + this.props.className : '')
        }
      >
        {this.props.orientation === 'table'
          ? this.renderAsTable()
          : this.renderSimple()}
      </div>
    );
  }

  renderAsTable() {
    const rows = [];
    let row = [];
    this.props.options.forEach((element, index) => {
      if (index % 2 === 0) {
        row = [];

        row.push(<div key={index}>{this.renderItemContent(element)}</div>);

        rows.push(row);
      } else {
        row.push(<div key={index}>{this.renderItemContent(element)}</div>);
      }
    });

    return (
      <table className="orientation-table">
        <tbody>
          {rows.map((row, index) => {
            return (
              <tr key={index}>
                <td>{row[0]}</td>
                <td>{row[1]}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  renderSimple() {
    return (
      <React.Fragment>
        {this.props.options.map((element, index) => {
          return (
            <div
              key={index}
              className={'orientation-simple ' + this.props.orientation}
            >
              {this.renderItemContent(element)}
            </div>
          );
        })}
      </React.Fragment>
    );
  }

  renderItemContent(element) {
    const { emptyPng, fullPng, fullPngReadOnly, value, readOnly } = this.props;
    const emptyPngSelected = emptyPng || roundEmptyPng;
    const fullPngSelected = fullPng || roundFullPng;
    const fullPngReadOnlySelected = fullPngReadOnly || roundFullReadOnlySvg;
    return (
      <React.Fragment>
        <img
          className={readOnly ? 'read-only' : null}
          src={
            element.value === value
              ? readOnly
                ? fullPngReadOnlySelected
                : fullPngSelected
              : emptyPngSelected
          }
          alt={element.selected ? 'selected' : 'not-selected'}
          onClick={(event) => this.handleChange(event, element.value)}
        />
        <span>{element.label}</span>
      </React.Fragment>
    );
  }
}

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/shared/radio-button/RadioButton.js